import React, { memo, useCallback } from 'react';
import { connect } from 'react-redux';

import { Text } from '@Sage/hoi-poi-ui';
import { RATES } from 'constants/Entities';
import useDrawerWidth from 'hooks/useDrawerWidth';
import EntityCrud from 'containers/components/EntityCrud';
import EntityCrudContent from 'containers/components/EntityCrud/EntityCrudContent';
import EntityCrudDelete from 'containers/components/EntityCrud/EntityCrudDelete';
import EntityCrudGeneric from 'containers/components/EntityCrud/EntityCrudGeneric';
import EntityCrudHeader from 'containers/components/EntityCrud/EntityCrudHeader';
import EntityCrudWrapper from 'containers/components/EntityCrud/EntityCrudWrapper';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const mapStateToProps = (state) => {
    const permissions = state.config?.permission;

    return {
        canDelete: permissions ? permissions.rates_delete : false,
        isOpen: state.entityCrud?.isOpen ?? false,
    };
};

const RatesCrud = memo(({ canDelete, isOpen }) => {
    const drawerWidth = useDrawerWidth({ entityType: RATES, isOpen });

    const getCrudTitle = useCallback((loading, id) => {
        if (loading) return null;
        return !id ? getLiteral('label_add_rate') : getLiteral('label_edit_rate');
    }, []);

    return (
        <EntityCrud
            className="rates-entity-crud"
            entity={RATES}
            hasCrudInDetail={false}
            width={drawerWidth}
        >
            {({ data, loading, loadingSave, onClose, onDelete, onSave, renderLoader }) => (
                <EntityCrudWrapper>
                    <EntityCrudHeader
                        cancelText={getLiteral('action_cancel')}
                        loading={loading}
                        loadingSave={loadingSave}
                        onCancel={onClose}
                        onSave={onSave}
                        saveText={getLiteral('action_save')}
                        title={getCrudTitle(loading, data?.id)}
                    />
                    <EntityCrudContent>
                        {loading && renderLoader()}
                        {!loading && (
                            <>
                                <EntityCrudGeneric formWidth="100%" isLateralCrud={true} />
                                {data?.id && canDelete ? (
                                    <EntityCrudDelete
                                        canDelete={canDelete}
                                        className="rates-entity-crud__delete"
                                        onDelete={onDelete}
                                        buttonText={getLiteral('action_delete')}
                                        modalTitle="action_delete"
                                        modalCancelText="action_cancel"
                                        modalConfirmText="action_confirm_bn"
                                    >
                                        <Text>{getLiteral('confirm_sure')}</Text>
                                    </EntityCrudDelete>
                                ) : null}
                            </>
                        )}
                    </EntityCrudContent>
                </EntityCrudWrapper>
            )}
        </EntityCrud>
    );
});

RatesCrud.displayName = 'RatesCrud';

export default connect(mapStateToProps)(RatesCrud);
